export default "__VITE_ASSET__BnN0ZCo5__"